import React from 'react';
import { Avatar, Typography } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';
import {
  string, oneOfType, arrayOf, shape, oneOf,
} from 'prop-types';

const { Text } = Typography;

const Empty = () => <Text type="secondary" italic>—</Text>;

const renderUser = (value) => {
  if (!value) return <Empty />;
  return (
    <span className="ticket-history__user">
      <Avatar size="small" src={value.avatarUrl} />
      <Text>{value.username}</Text>
    </span>
  );
};

const renderArray = (value) => {
  if (!value || value.length === 0) return <Empty />;
  return <Text>{value.join(', ')}</Text>;
};

const renderPlain = (value) => (value ? <Text>{value}</Text> : <Empty />);

const RENDERERS = {
  user: renderUser,
  array: renderArray,
  enum: renderPlain,
  date: renderPlain,
  text: renderPlain,
};

const ChangeRow = ({
  label, kind, from = null, to = null,
}) => {
  const render = RENDERERS[kind] || renderPlain;

  return (
    <div className="ticket-history__change">
      <Text type="secondary" className="ticket-history__change-label">{`${label}:`}</Text>
      <span className="ticket-history__change-from">{render(from)}</span>
      <ArrowRightOutlined className="ticket-history__change-arrow" />
      <span className="ticket-history__change-to">{render(to)}</span>
    </div>
  );
};

ChangeRow.propTypes = {
  label: string.isRequired,
  kind: oneOf(['user', 'enum', 'date', 'text', 'array']).isRequired,
  from: oneOfType([string, shape({}), arrayOf(string)]),
  to: oneOfType([string, shape({}), arrayOf(string)]),
};

export default ChangeRow;
